<template>
  <div class="inline-editor-container" :class="{showInput}">
    <editor class="inline-editor" v-model="myValue" :init="init" :disabled="disabled" @onClick="onClick" :ref="id"/>
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/icons/default/icons'
import 'tinymce/themes/silver'
import 'tinymce/skins/ui/oxide/skin.css'
import 'tinymce/skins/ui/oxide/content.inline.css'
import 'tinymce/plugins/image'
import 'tinymce/plugins/media'
import 'tinymce/plugins/table'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/link'
import 'tinymce/plugins/quickbars'

import oss from '@/utils/file/oss'

export default {
  name: 'inline-editor',
  components: {
    Editor
  },
  props: {
    // 传入一个value，使组件支持v-model绑定
    id: {
      type: String,
      default: 'vue-tinymce-' + +new Date()
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否纯文本，纯文本时toolbar失效且返回的值不包含html标签
    plaintext: {
      type: Boolean,
      default: false
    },
    // 显示输入框
    showInput: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default: 'quickbars link table image media'
    },
    toolbar: {
      type: [String, Array],
      default: 'fontsizeselect lineheight bold italic forecolor | link blockquote image media quicktable'// blockquote
    }
  },
  data () {
    return {
      init: {},
      myValue: this.value
    }
  },
  mounted () {
    tinymce.init({})
    this.editorInit()
  },
  created () {
    this.editorInit()
  },
  methods: {
    editorInit () {
      let _this = this
      this.init = {
        // 页面提示找不到zh_CN.js时需要build一下
        language_url: '/research-pc/static/tinymce/langs/zh_CN.js',
        language: 'zh_CN',
        skin_url: '/research-pc/static/tinymce/skins/ui/oxide',
        toolbar: this.plaintext ? null : this.toolbar, // 隐藏工具栏
        menubar: false, // 隐藏菜单栏
        inline: true, // 开启内联模式
        plugins: this.plugins, // 选择需加载的插件
        // 选中时出现的快捷工具，与插件有依赖关系
        quickbars_selection_toolbar: false,
        quickbars_insert_toolbar: false,
        fontsize_formats: '6px 10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 36px 40px 46px',
        lineheight_formats: '6px 10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 36px 40px 46px',
        images_upload_handler: (blobInfo, success, failure, progress) => {
          const loading = _this.$loading({
            lock: true,
            text: '上传中'
          })
          progress(0)
          oss.upload(blobInfo.blob()).then(data => {
            loading.close()
            let url = data.fileUrl
            success(url)
            progress(100)
          }).catch(err => {
            loading.close()
            console.info(err)
          })
        },
        file_picker_callback: function (callback, value, meta) {
          let accept = '*'
          if (meta.filetype === 'media') {
            accept = 'video/*'
          }
          if (meta.filetype === 'image') {
            accept = 'image/*'
          }
          let input = document.createElement('input')
          input.setAttribute('type', 'file')
          input.setAttribute('accept', accept)
          input.onchange = function () {
            let file = this.files[0]
            let fileType = file.type
            if (meta.filetype === 'media' && fileType.indexOf('video') < 0) {
              alert('请选择视频文件上传！')
              return
            }
            if (meta.filetype === 'image' && fileType.indexOf('image') < 0) {
              alert('请选择图片文件上传！')
              return
            }
            const loading = _this.$loading({
              lock: true,
              text: '上传中',
              customClass: 'm_loading_mask',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            oss.upload(file).then(data => {
              loading.close()
              let url = data.fileUrl
              callback(url, {
                alt: data.fileName
              })
            }).catch(err => {
              loading.close()
              console.info(err)
            })
          }
          input.click()
        }
      }
    },
    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    // 需要什么事件可以自己增加
    onClick (e) {
      this.$emit('onClick', e, tinymce)
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear () {
      this.myValue = ''
    }
  },
  watch: {
    value (newValue) {
      if (!this.plaintext) {
        this.myValue = newValue
      }
    },
    myValue (newValue) {
      let text = tinymce.activeEditor ? tinymce.activeEditor.getContent({ format: 'text' }) : ''
      if (this.plaintext) {
        this.$emit('input', text)
      } else {
        this.$emit('input', newValue)
      }
      // 返回纯文本
      this.$emit('update:text', text)
    },
    $route () {
      tinymce.remove('div.textarea')
    }
  }
}
</script>

<style scoped lang="scss">
.inline-editor-container{
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px dashed transparent;
  .inline-editor{
    max-width: calc(100% - 100px);
  }
  /deep/
  p{
    margin: 0;
  }
}
.inline-editor-container:hover{
  border-color: #909399;
}
// 子元素选中触发
.inline-editor-container:focus-within{
  border-color: #909399;
  background-color: #F2F6FC;
}
.showInput:after{
  content: "";
  display: block;
  height: 22px;
  width: 100px;
  border-radius: 4px;
  border: 1px solid #D5D5D5;
}
</style>



// WEBPACK FOOTER //
// src/components/Tinymce/inline-editor.vue